//import { apiRequest } from "./ActionUtils"

export function changeInputValue(name, value) {
  return function(dispatch) {
    dispatch({
      type: 'DIALOGTESTMODE_CHANGE_INPUT_VALUE',
      payload: {name, value}
    });
  }
}